import { EventTypes, track, getPageSource } from '@mc/track-event'

export const trackVideoModalClose = ({
  uuid,
  categorySlug,
}: {
  uuid: string
  categorySlug: string
}) => {
  track(EventTypes.CATALOG_PAGE_CLICK, {
    action: 'close_player',
    uuid,
    location: 'video_playlist_module_sample',
    page_source: getPageSource(),
    category: categorySlug,
  })
}

export const trackSubcategoryClicked = ({
  categorySlug,
  subcategoryName,
}: {
  categorySlug: string
  subcategoryName: string
}) => {
  const eventsProps = {
    action: 'sub_category_selected',
    location: 'trending_skills',
    subcategoryName,
    category: categorySlug,
  }

  track(EventTypes.CATALOG_PAGE_CLICK, {
    ...eventsProps,
  })
}

export const trackInstructorClicked = ({
  classSlug,
}: {
  classSlug: string
}) => {
  const eventsProps = {
    action: 'instructor_click',
    location: 'trending_instructors',
    class: classSlug,
    categoryName: 'all-classes',
    page_source: 'Category',
  }

  track(EventTypes.CATALOG_PAGE_CLICK, {
    ...eventsProps,
  })
}

export const trackInstructorOutcomeClicked = ({
  classSlug,
  outcomeSlug,
}: {
  classSlug: string
  outcomeSlug: string
}) => {
  const eventsProps = {
    action: 'instructor_outcome_click',
    location: 'trending_instructors',
    class: classSlug,
    categoryName: 'all-classes',
    page_source: 'Category',
    outcome: outcomeSlug,
  }

  track(EventTypes.CATALOG_PAGE_CLICK, {
    ...eventsProps,
  })
}

type ArrowDirection = 'left' | 'right'

const trackCarouselArrowClick = ({
  arrow,
  location,
}: {
  arrow: ArrowDirection
  location: string
}) => {
  track(EventTypes.CATALOG_PAGE_CLICK, {
    action: arrow,
    location,
  })
}

export const trackCarouselClickPrev = ({ location }: { location: string }) => {
  trackCarouselArrowClick({ arrow: 'left', location })
}

export const trackCarouselClickNext = ({ location }: { location: string }) => {
  trackCarouselArrowClick({ arrow: 'right', location })
}
